<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part02"><a id="page_17"></a><strong>II<br/>OUT OF THE REVOLUTION</strong></h2>
<p class="blockquotem"><em>The stars have gleamed with a pitying light<br/>On the scene of many a hopeless fight,<br/>On a prairie patch or a haunted wood<br/>Where a little bunch of Rangers stood</em>.</p>
<p class="blockquotem"><em>They fought grim odds and knew no fear,<br/>They kept their honor high and clear,<br/>And, facing arrows, guns, and knives,<br/>Gave Texas all they had—their lives</em>.</p>
<p class="att">W. A. P<span class="small">HELSON</span><a id="page_18"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part02.vue?8d3f8922